export const ARE_YOU_SURE_YOU_WANT_TO = {
    id: 'oe.confirm.areYouSureTo',
    description: 'Confirm message',
    defaultMessage: 'Are you sure you want to'
};